export default __webpack_public_path__ + "static/media/abcdropthree.d2718c16.png";